import React from "react";
import DOMPurify from "dompurify";
const ScenarioQuestionformat = (props)=>{ 
      const sanitizedHtml = DOMPurify.sanitize(props.scenario);
    return <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};
export default ScenarioQuestionformat;


// import React from "react";
// const ScenarioQuestionformat = (props)=>{ 
//     let quotes;
//     if(props.scenario){
//         quotes = props.scenario.replace(/<td[^>]*>(\s|&nbsp;)*<\/td>/g, '').replace(/<tr[^>]*>(\s|&nbsp;)*<\/tr>/g, '')       
//     }
// return(    
//     <> <div dangerouslySetInnerHTML={{ __html:quotes }} />   </>
// )
// };
// export default ScenarioQuestionformat;